import React from 'react';
import { motion } from 'framer-motion';
import { CalendarX2, MessageSquareOff, TrendingDown } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <CalendarX2 className="w-8 h-8 text-brand-pink" data-id="element-115" />,
    title: 'Gabinete Vacío',
    desc: 'Horas muertas esperando que suene el teléfono o alguien te escriba por Instagram.'
  }, {
    icon: <MessageSquareOff className="w-8 h-8 text-brand-pink" data-id="element-116" />,
    title: 'Te clavan el visto',
    desc: 'Pasás precio y desaparecen. Sentís que competís solo por ser la más barata.'
  }, {
    icon: <TrendingDown className="w-8 h-8 text-brand-pink" data-id="element-117" />,
    title: 'Inflación que asfixia',
    desc: 'Tus insumos suben todas las semanas pero te da miedo aumentar tus precios y perder clientas.'
  }];
  return <section className="py-20 bg-[#050505] relative border-y border-white/5" data-id="element-118">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-120">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-121">
            ¿Te suena <span className="text-brand-pink italic" data-id="element-122">familiar?</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg" data-id="element-123">
            Sabés depilar perfectamente, pero nadie te enseñó a vender, a cobrar
            o a manejar la inflación.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-124">
          {problems.map((prob, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-brand-black p-8 rounded-2xl border border-white/5 hover:border-brand-pink/30 transition-colors" data-id="element-125">
              <div className="w-16 h-16 bg-brand-pink/10 rounded-2xl flex items-center justify-center mb-6" data-id="element-126">
                {prob.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-127">
                {prob.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-128">{prob.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-129">
          <p className="text-2xl md:text-3xl font-serif font-medium text-white" data-id="element-130">
            Tener el gabinete vacío o trabajar 12 horas por monedas no es falta
            de talento. <br className="hidden md:block" data-id="element-131" />
            <span className="text-brand-pink font-bold italic" data-id="element-132">
              Es falta de SISTEMA.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}